// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ggki","notes":"Notes_notes__2QNOJ"};